import { useMemo } from 'react';
import { useIsShowStorageErrorApplicable } from './useIsShowStorageErrorApplicable';
import { useStorageErrorDialogEnabled } from './useStorageErrorDialogEnabled';
export var useIsShowStorageErrorDialogApplicable = function () {
    var isShowStorageErrorApplicable = useIsShowStorageErrorApplicable();
    var isStorageErrorDialogEnabled = useStorageErrorDialogEnabled();
    var isShowStorageErrorDialogApplicable = useMemo(function () {
        return isShowStorageErrorApplicable && isStorageErrorDialogEnabled;
    }, [isShowStorageErrorApplicable, isStorageErrorDialogEnabled]);
    return isShowStorageErrorDialogApplicable;
};
//# sourceMappingURL=useIsShowStorageErrorDialogApplicable.js.map